import PubSub from 'pubsub-js';
import { gsap } from 'gsap';
import { drumroll as Drumroll } from './drumroll';

const $html = $('html');
const $targetIntersection = '.content.-strength1 .-intersection';
const $targetParent = $('.content.-strength1');
const $contentNumbers = $('.content__numbers', $targetParent);

const tweens = [];

let startDrumrollId = null;

const startDrumroll = () => {
  $('.content__numberGruop', $targetParent).each((index, element) => {
    const drumroll = $('.content__numberDrumroll', element);
    const toNumber = drumroll.data('number');
    const tween = gsap.fromTo(
      drumroll,
      {
        textContent: 0,
      },
      {
        textContent: toNumber,
        duration: 1.5,
        delay: index * 1.5,
        ease: "power4.out",
        snap: { textContent: 1 },
        onComplete: () => {
          $(element).addClass('-startNumber');
        },
      },
    );
    tweens.push(tween);
  });

}

const intersection = () => {
  const targets = document.querySelectorAll(`${$targetIntersection}`);

  const options = {
    root: null,
    rootMargin: '0px 0px',
    threshold: 0.5,
  };
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          if (!$(entry.target).hasClass('-intersectionIsEntry')) {
            startDrumroll();
            $(entry.target).addClass('-intersectionIsEntry');
          }
      }
    });
  }, options);

  targets.forEach(target => {
    observer.observe(target);
  });
};

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device === 'mobile') {
        intersection();
    }
});

PubSub.subscribe('top.strength1.show', () => {
  startDrumrollId = setTimeout(() => {
    $contentNumbers.addClass('-intersectionIsEntry');
    startDrumroll();
  }, 500);
});

PubSub.subscribe('top.strength1.hide', () => {
  clearTimeout(startDrumrollId);
  $('.content__numberGruop', $targetParent).each((index, element) => {
    $(element).removeClass('-startNumber');
  });
  tweens.forEach((element) => {
    element.kill();
  });
  $contentNumbers.removeClass('-intersectionIsEntry');
});